import 'react-toastify/dist/ReactToastify.css';
import Highcharts from 'highcharts';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsReact from 'highcharts-react-official';
import React, { useEffect, useRef, useState } from 'react';
import SummaryTable from './tables/Unitlist';
import SummaryTableOverall from './tables/summarytable';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import {
  Card,
  CardBody,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
} from 'reactstrap';

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

// Function to store selected items in sessionStorage
const saveToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify([...value])); // Convert Set to array before storing
};
// // Function to load selected items from sessionStorage
const loadFromSessionStorage = (key) => {
  const savedData = sessionStorage.getItem(key);
  return savedData ? new Set(JSON.parse(savedData)) : new Set(); // Parse and convert back to Set
};

// Function to remove selected items from sessionStorage
const removeFromSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

const UnitQc = () => {
  document.title = 'Linc Quality Hub';

  const toggleMilestoneDropdown = () => {
    setMilestoneDropdownOpen((prev) => !prev);
  };

  // State for dropdowns and selected items
  const [universityDropdownOpen, setUniversityDropdownOpen] = useState(false);
  const [programDropdownOpen, setProgramDropdownOpen] = useState(false);
  const [timelineDropdownOpen, setTimelineDropdownOpen] = useState(false);
  const [termDropdownOpen, setTermDropdownOpen] = useState(false);
  const [selectedUniversities, setSelectedUniversities] = useState(new Set());
  const [appliedUniversities, setAppliedUniversities] = useState(new Set());
  const [appliedTerms, setAppliedTerms] = useState(new Set()); // New state for applied terms
  const [timelineYears, setTimelineYears] = useState([]);
  const [timelineTerms, setTimelineTerms] = useState([]);
  const [selectedTimelines, setSelectedTimelines] = useState(new Set());
  const [appliedTimelines, setAppliedTimelines] = useState(new Set());
  const [selectedPrograms, setSelectedPrograms] = useState(new Set());
  const [appliedPrograms, setAppliedPrograms] = useState(new Set()); // New state for applied terms
  const [unitData, setUnitData] = useState(null);
  const [tableData, setTableFData] = useState(null);
  const [summarytabledata, setSummary] = useState(null);
  const [loading, setLoading] = useState(true); // New loading state
  const [loading1, setLoading1] = useState(false);
  const [selectedTerms, setSelectedTerms] = useState(new Set()); // New state for selected terms
  const [programs, setPrograms] = useState([]);
  const [milestoneDropdownOpen, setMilestoneDropdownOpen] = useState(false);
  const [selectedMilestones, setSelectedMilestones] = useState(new Set());
  const [appliedmilestone, setAppliedmileStone] = useState(new Set());
  const [milestone, setMilestone] = useState([]);
  const [timelineMilestone, setTimelineMilestone] = useState([]);
  const [milestonetypeDropdownOpen, setMilestonetypeDropdownOpen] =
    useState(false);
  const [selectedMilestonestype, setSelectedMilestonestype] = useState(
    new Set(),
  );
  const [appliedmilestonetype, setAppliedMilestonetype] = useState(new Set()); // New state for applied terms
  const [timelineMilestonetype, setTimelineMilestonetype] = useState([]);
  const [unitMilestonetypeDropdownOpen, setUnitMilestonetypeDropdownOpen] =
    useState([]);
  const [unitMilestoneDropdownOpen, setUnitMilestoneDropdownOpen] = useState(
    [],
  );
  // // console.log("unitDatausestate", unitData)

  // State for fetched data
  const [universities, setUniversities] = useState([]);

  //search option
  const [universitySearch, setUniversitySearch] = useState('');
  const [programSearch, setProgramSearch] = useState('');
  const [timelineSearch, setTimelineSearch] = useState('');
  const [termSearch, setTermSearch] = useState('');
  const [milestoneTypeSearch, setMilestoneTypeSearch] = useState('');
  const [milestoneSearch, setMilestoneSearch] = useState('');
  const [loadingFilter, setLoadingFilters] = useState(false);

const isUrlFlowRef = useRef(false);
const isUrlFlowDoneRef = useRef(false);
const isApplyingRef = useRef(false);

/* =======================
   ROUTE PARAMS
======================= */
const location = useLocation();
const query = new URLSearchParams(location.search);

const urlUniversity = query.get('universityid');
const urlProgram = query.get('program_id');
const urlYear = query.get('year');
const urlTerm = query.get('term');

const hasUrlParams =
  urlUniversity || urlProgram || urlYear || urlTerm;

/* =======================
   URL FLOW — STEP 1
   SET UNIVERSITY
======================= */
useEffect(() => {
  if (!urlUniversity) return;

  isUrlFlowRef.current = true; // 🔒 lock manual flow

  const uniSet = new Set([Number(urlUniversity)]);
  setSelectedUniversities(uniSet);
  setAppliedUniversities(uniSet);

  saveToSessionStorage('appliedUniversities', uniSet);
}, []);

/* =======================
   MANUAL FLOW
   UNIVERSITY → PROGRAMS
======================= */
useEffect(() => {
  if (isUrlFlowRef.current) return;

  if (selectedUniversities.size > 0) {
    fetchDataProgram();
  }
}, [selectedUniversities]);

/* =======================
   URL FLOW — STEP 2
   SET PROGRAM
======================= */
useEffect(() => {
  if (!isUrlFlowRef.current) return;
  if (!urlProgram) return;
  if (!programs.length) return;

  const progSet = new Set([Number(urlProgram)]);
  setSelectedPrograms(progSet);
  setAppliedPrograms(progSet);

  saveToSessionStorage('appliedPrograms', progSet);
}, [programs]);

/* =======================
   MANUAL FLOW
   PROGRAM → YEAR
======================= */
useEffect(() => {
  if (isUrlFlowRef.current) return;

  if (
    selectedUniversities.size > 0 &&
    selectedPrograms.size > 0
  ) {
    fetchDataYear();
  }
}, [selectedUniversities, selectedPrograms]);

/* =======================
   URL FLOW — STEP 3
   SET YEAR
======================= */
useEffect(() => {
  if (!isUrlFlowRef.current) return;
  if (!urlYear) return;
  if (!timelineYears.length) return;

  const yearSet = new Set([urlYear]);
  setSelectedTimelines(yearSet);
  setAppliedTimelines(yearSet);

  saveToSessionStorage('appliedTimelinesunitqc', yearSet);
}, [timelineYears]);

/* =======================
   MANUAL FLOW
   YEAR → TERM
======================= */
useEffect(() => {
  if (isUrlFlowRef.current) return;

  if (
    selectedUniversities.size > 0 &&
    selectedTimelines.size > 0
  ) {
    fetchDataTerm();
  }
}, [selectedTimelines]);

/* =======================
   URL FLOW — STEP 4
   SET TERM
   + RELEASE URL LOCK
======================= */
useEffect(() => {
  if (!isUrlFlowRef.current) return;
  if (!urlTerm) return;
  if (!timelineTerms.length) return;

  const termSet = new Set([urlTerm]);
  setSelectedTerms(termSet);
  setAppliedTerms(termSet);

  saveToSessionStorage('appliedTermsunitqc', termSet);

  // ✅ URL FLOW COMPLETE
  isUrlFlowDoneRef.current = true;

  // 🔓 UNLOCK MANUAL FLOW (CRITICAL FIX)
  isUrlFlowRef.current = false;
}, [timelineTerms]);

/* =======================
   RESET ON UNIVERSITY CHANGE
======================= */
useEffect(() => {
  if (!isUrlFlowDoneRef.current) return;

  setSelectedPrograms(new Set());
  setSelectedTimelines(new Set());
  setSelectedTerms(new Set());

  setAppliedPrograms(new Set());
  setAppliedTimelines(new Set());
  setAppliedTerms(new Set());
}, [selectedUniversities]);

/* =======================
   RESET ON PROGRAM CHANGE
======================= */
useEffect(() => {
  if (!isUrlFlowDoneRef.current) return;

  setSelectedTimelines(new Set());
  setSelectedTerms(new Set());

  setAppliedTimelines(new Set());
  setAppliedTerms(new Set());
}, [selectedPrograms]);

  //load filters in session stoarage
  useEffect(() => {
    setLoading(true);
    setAppliedUniversities(loadFromSessionStorage('appliedUniversities'));
    setAppliedPrograms(loadFromSessionStorage('appliedPrograms'));
    setAppliedTimelines(loadFromSessionStorage('appliedTimelinesunitqc'));
    setAppliedTerms(loadFromSessionStorage('appliedTermsunitqc'));
    setAppliedMilestonetype(
      loadFromSessionStorage('appliedmilestoetypeunitqc'),
    );
    setAppliedmileStone(loadFromSessionStorage('appliedmilestoeunitqc'));

    // Handle teacherid directly if passed from another page
    setSelectedPrograms(loadFromSessionStorage('appliedPrograms'));
    setSelectedUniversities(loadFromSessionStorage('appliedUniversities'));
    setSelectedTimelines(loadFromSessionStorage('selectedTimelinesunitqc'));
    setSelectedTerms(loadFromSessionStorage('selectedTermsunitqc'));
    setSelectedMilestonestype(
      loadFromSessionStorage('selectedmilestonetypeunitqc'),
    );
    setSelectedMilestones(loadFromSessionStorage('selectedmilestoneunitqc'));

    setLoading(false);
  }, []);

  const handleSearchChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case 'university':
        setUniversitySearch(value);
        break;
      case 'program':
        setProgramSearch(value);
        break;
      case 'timeline':
        setTimelineSearch(value);
        break;
      case 'term':
        setTermSearch(value);
        break;
      case 'milestoneType':
        setMilestoneTypeSearch(value);
        break;
      case 'milestone':
        setMilestoneSearch(value);
        break;
      default:
        break;
    }
  };

  const filterUniversities = (universitySearch) => {
    return universities.filter((u) =>
      u.university_name.toLowerCase().includes(universitySearch.toLowerCase()),
    );
  };

  const filterPrograms = (programSearch) => {
    return programs.filter(([id, name]) =>
      name.toLowerCase().includes(programSearch.toLowerCase()),
    );
  };

  const filterTimeline = (timelineSearch) => {
    return timelineYears.filter((year) => year.includes(timelineSearch));
  };

  const filterTerms = (termSearch) => {
    return timelineTerms.filter((term) =>
      term.toLowerCase().includes(termSearch.toLowerCase()),
    );
  };
  const filterMilestoneTypes = (search) => {
    return timelineMilestonetype.filter((type) =>
      type.toLowerCase().includes(search.toLowerCase()),
    );
  };

  const filterMilestones = (search) => {
    return timelineMilestone.filter((milestone) =>
      milestone.toString().includes(search),
    );
  };

  const toggleUniversityDropdown = () => {
    setUniversityDropdownOpen((prev) => !prev);
  };

  const toggleTimelineDropdown = () => {
    setTimelineDropdownOpen((prev) => !prev);
  };
  const toggleProgramDropdown = () => {
    setProgramDropdownOpen((prev) => !prev);
  };
  const toggleTermDropdown = () => {
    setTermDropdownOpen((prev) => !prev); // Toggle term dropdown
  };

  const toggleMilestonetypeDropdown = () =>
    setMilestonetypeDropdownOpen((prev) => !prev);

  const toggleMilestonetypeunitDropdown = () =>
    setUnitMilestonetypeDropdownOpen((prev) => !prev);

  const toggleMilestoneunitDropdown = () =>
    setUnitMilestoneDropdownOpen((prev) => !prev);

  const handleSelectItem = (
    item,
    selectedSet,
    setSelectedSet,
    toggleDropdown,
  ) => {
    let newSelection = new Set(selectedSet);

    // If the item is part of universities or programs (which allow multiple selections), handle accordingly
    if (
      item.removename === 'removeuniversity' ||
      item.removename === 'removeprograms'
    ) {
      // If the selected item is already chosen, allow deselection
      if (selectedSet.has(item.id)) {
        newSelection.delete(item.id);
      } else {
        newSelection.add(item.id);
      }
    } else if (
      item.removename === 'removeyears' ||
      item.removename === 'removestudyperiod' ||
      item.removename === 'removemilestone' ||
      item.removename === 'removemilestonetype'
    ) {
      // If the item is part of year or study period (single selection)
      newSelection.clear(); // Clear all previous selections
      // newSelection.delete(item.id);
      newSelection.add(item.id); // Add the new selection
    }

    // Clear dependent selections when an item is deselected
    if (item.removename === 'removeuniversity') {
      setSelectedPrograms(new Set());
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setSelectedMilestones(new Set());
      setSelectedMilestonestype(new Set());
      setPrograms([]);
      setTimelineYears([]);
      setTimelineTerms([]);
      setTimelineMilestone([]);
      setTimelineMilestonetype([]);
    } else if (item.removename === 'removeprograms') {
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setSelectedMilestones(new Set());
      setSelectedMilestonestype(new Set());
      setTimelineYears([]);
      setTimelineTerms([]);
      setTimelineMilestone([]);
      setTimelineMilestonetype([]);
    } else if (item.removename === 'removeyears') {
      setSelectedTerms(new Set());
      setTimelineTerms([]);
      setSelectedMilestones(new Set());
      setSelectedMilestonestype(new Set());
      setTimelineMilestone([]);
      setTimelineMilestonetype([]);
    } else if (item.removename === 'removestudyperiod') {
      setSelectedMilestones(new Set());
      setSelectedMilestonestype(new Set());
      setTimelineMilestone([]);
      setTimelineMilestonetype([]);
    } else if (item.removename === 'removemilestonetype') {
      setSelectedMilestones(new Set());
      setTimelineMilestone([]);
    }

    setSelectedSet(newSelection);
    toggleDropdown();
  };

  const isItemSelected = (itemId, selectedSet) => selectedSet.has(itemId);
  const isTermSelected = (selectedTerm) => selectedTerms.has(selectedTerm);
  const handleSelectItemTimeLine = (selectedYear) => {
    const newSelection = new Set(selectedTimelines);
    if (newSelection.has(selectedYear)) {
      newSelection.delete(selectedYear);
    } else {
      newSelection.add(selectedYear);
    }
    setSelectedTimelines(newSelection);
  };
  const isTimelineSelected = (selectedYear) =>
    selectedTimelines.has(selectedYear);
  const isProgramsSelected = (selectedProgram) =>
    selectedPrograms.has(selectedProgram);
  const ismilestoneSelected = (selectedMilestone) =>
    selectedMilestones.has(selectedMilestone);
  const ismilestonetypemSelected = (selectedMiletype) =>
    selectedMilestonestype.has(selectedMiletype);

  const handleApply = () => {
    if (selectedUniversities.size === 0) {
      toast.error('Please choose a university.');
      return;
    }
    if (selectedPrograms.size === 0) {
      toast.error('Please choose a program.');
      return;
    }
    if (selectedTimelines.size === 0) {
      toast.error('Please choose a year.');
      return;
    }
    if (selectedTerms.size === 0) {
      toast.error('Please choose a study period.');
      return;
    }
    // if (selectedMilestonestype.size === 0) {
    //   toast.error("Please choose a milestone type.");
    //   return;
    // }
    // if (selectedMilestones.size === 0) {
    //   toast.error("Please choose a milestone.");
    //   return;
    // }
    // Apply selections
    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedPrograms(new Set(selectedPrograms));
    setAppliedmileStone(new Set(selectedMilestones));
    setAppliedMilestonetype(new Set(selectedMilestonestype));

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('appliedTimelinesunitqc', selectedTimelines);
    saveToSessionStorage('appliedTermsunitqc', selectedTerms);
    saveToSessionStorage('appliedPrograms', selectedPrograms);

    saveToSessionStorage('selectedUniversitiesunitqc', selectedUniversities);
    saveToSessionStorage('selectedTimelinesunitqc', selectedTimelines);
    saveToSessionStorage('selectedProgramsunitqc', selectedPrograms);
    saveToSessionStorage('selectedTermsunitqc', selectedTerms);

    saveToSessionStorage('appliedmilestoetypeunitqc', selectedMilestonestype);
    saveToSessionStorage('appliedmilestoeunitqc', selectedMilestones);
    saveToSessionStorage('selectedmilestonetypeunitqc', selectedMilestonestype);
    saveToSessionStorage('selectedmilestoneunitqc', selectedMilestones);

    // Close all dropdowns
    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setMilestonetypeDropdownOpen(false);
    setMilestoneDropdownOpen(false);
  };

  const handleApplyMilestone = () => {
    if (selectedUniversities.size === 0) {
      toast.error('Please choose a university.');
      return;
    }
    if (selectedPrograms.size === 0) {
      toast.error('Please choose a program.');
      return;
    }
    if (selectedTimelines.size === 0) {
      toast.error('Please choose a year.');
      return;
    }
    if (selectedTerms.size === 0) {
      toast.error('Please choose a study period.');
      return;
    }
    if (selectedMilestonestype.size === 0) {
      toast.error('Please choose a Milestonetype.');
      return;
    }
    if (selectedMilestones.size === 0) {
      toast.error('Please choose a Milestone.');
      return;
    }

    // if (selectedMilestonestype.size === 0) {
    //   toast.error("Please choose a milestone type.");
    //   return;
    // }
    // if (selectedMilestones.size === 0) {
    //   toast.error("Please choose a milestone.");
    //   return;
    // }
    // Apply selections
    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedPrograms(new Set(selectedPrograms));
    setAppliedmileStone(new Set(selectedMilestones));
    setAppliedMilestonetype(new Set(selectedMilestonestype));

    saveToSessionStorage('appliedUniversitiesunitqc', selectedUniversities);
    saveToSessionStorage('appliedTimelinesunitqc', selectedTimelines);
    saveToSessionStorage('appliedTermsunitqc', selectedTerms);
    saveToSessionStorage('appliedProgramsunitqc', selectedPrograms);

    saveToSessionStorage('selectedUniversitiesunitqc', selectedUniversities);
    saveToSessionStorage('selectedTimelinesunitqc', selectedTimelines);
    saveToSessionStorage('selectedProgramsunitqc', selectedPrograms);
    saveToSessionStorage('selectedTermsunitqc', selectedTerms);

    saveToSessionStorage('appliedmilestoetypeunitqc', selectedMilestonestype);
    saveToSessionStorage('appliedmilestoeunitqc', selectedMilestones);
    saveToSessionStorage('selectedmilestonetypeunitqc', selectedMilestonestype);
    saveToSessionStorage('selectedmilestoneunitqc', selectedMilestones);

    // Close all dropdowns
    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setMilestonetypeDropdownOpen(false);
    setMilestoneDropdownOpen(false);
  };

  const user_token = localStorage.getItem('usertoken');

  const fetchDataTabs = async () => {
    try {
      const payload = {
        mode: 'tabs',
        // user_id: parseInt(uid)
      };

      // console.log("Sending tabs request with token:", user_token);  // 🔍
      // console.log("Payload:", payload);

      const tabResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        },
      );
      localStorage.setItem('tabs', JSON.stringify(tabResponse.data));

      // console.log("Tabs Response:", tabResponse);
    } catch (error) {
      // console.log('Error fetching tab data:', error);
    }
  };

  useEffect(() => {
    fetchDataTabs();
  }, []);
  const fetchData = async () => {
    try {
      // setLoading(true);
      setLoadingFilters(true);
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setUniversities(response.universities || []); // Ensure we set to an empty array if undefined
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingFilters(false);
      // setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (selectedUniversities && selectedUniversities.size > 0) {
      fetchDataProgram();
    }
  }, [selectedUniversities]);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0
    ) {
      fetchDataYear();
    }
  }, [selectedUniversities, selectedPrograms]);

  const fetchDataProgram = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        mode: 'metrics',
        sub_mode: 'program',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setPrograms(unitResponse.program || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  const fetchDataYear = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,

        mode: 'metrics',
        sub_mode: 'year',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setTimelineYears(unitResponse.year || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };
  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedTimelines.size > 0
    ) {
      fetchDataTerm();
    }
  }, [selectedUniversities, selectedTimelines]);

  const fetchDataTerm = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,

        mode: 'teacher_report',
        sub_mode: 'term',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0
    ) {
      fetchDataMileStonetype();
    }
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  const fetchDataMileStonetype = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,

        mode: 'teacher_qc',
        sub_mode: 'milestone_type',
        //  milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineMilestonetype(unitResponse.milestone_types || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };
  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0 &&
      selectedMilestonestype.size > 0
    ) {
      fetchDataMileStone();
    }
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
    selectedMilestonestype,
  ]);
  const fetchDataMileStone = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
        milestone_type:
          selectedMilestonestype.size > 0
            ? Array.from(selectedMilestonestype)[0]
            : null,

        mode: 'unit_qc',
        sub_mode: 'milestone',
        //  milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineMilestone(unitResponse.milestone || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  //refresh data for 500 error
  const resetData = () => {
    setUnitData(null);
    setTableFData(null);
    setSummary(null);
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      (appliedUniversities && appliedUniversities.size > 0,
        appliedTimelines && appliedTimelines.size > 0,
        appliedTerms && appliedTerms.size > 0)
    ) {
      fetchDataUnitqc();
    }
  }, [
    appliedUniversities,
    appliedTimelines,
    appliedTerms,
    appliedPrograms,
    appliedmilestone,
  ]);

  // const fetchDataUnitqc = async () => {
  //   try {
  //     setLoading(true);

  //     const payload = {
  //       university:
  //         appliedUniversities.size > 0
  //           ? Array.from(appliedUniversities)
  //           : null,
  //       year: appliedTimelines.size > 0 ? Array.from(appliedTimelines) : null,
  //       term: appliedTerms.size > 0 ? Array.from(appliedTerms) : null,
  //       program: appliedPrograms.size > 0 ? Array.from(appliedPrograms) : null,
  //       // milestone_type: "completion",
  //       milestone: appliedmilestone.size > 0 ? Array.from(appliedmilestone) : null,
  //       milestone_type: appliedmilestonetype.size > 0 ? Array.from(appliedmilestonetype)[0] : null,
  //       sub_mode: "milestone",

  //     };

  //     const unitResponse = await axios.post(process.env.REACT_APP_API_BASE_URL + 'unit_qc/', payload);

  //     setUnitData(unitResponse.card_data)
  //      setTableFData(unitResponse.unit_metrics_report);
  //     setSummary(unitResponse.summary);

  //     if (unitResponse.status === 500) {
  //       resetData();
  //     }

  //     // console.log("unit data", unitResponse);
  //   } catch (error) {
  //     // console.log('error fetching unit qc', error);
  //     resetData();

  //   }
  //   finally {
  //     setLoading(false)
  //   }
  // };

  const fetchDataUnitqc = async () => {
    try {
      const hasMilestoneData =
        selectedMilestones.size > 0 || selectedMilestonestype.size > 0;
      const hasOtherFilters =
        appliedUniversities.size > 0 ||
        appliedTimelines.size > 0 ||
        appliedTerms.size > 0 ||
        appliedPrograms.size > 0;

      if (!hasMilestoneData && !hasOtherFilters) {
        return; // Exit early if all filters are empty
      }

      // Set loaders based on conditions
      if (hasMilestoneData) {
        setLoading(true); // Show screen loader if milestone data exists
      }

      if (!hasMilestoneData && hasOtherFilters) {
        setLoading1(true); // Show table loader only if milestone is empty
      }

      const payload = {
        university:
          appliedUniversities.size > 0 ? Array.from(appliedUniversities) : null,
        year: appliedTimelines.size > 0 ? Array.from(appliedTimelines) : null,
        term: appliedTerms.size > 0 ? Array.from(appliedTerms) : null,
        program: appliedPrograms.size > 0 ? Array.from(appliedPrograms) : null,
        milestone:
          appliedmilestone.size > 0 ? Array.from(appliedmilestone) : null,
        milestone_type:
          appliedmilestonetype.size > 0
            ? Array.from(appliedmilestonetype)[0]
            : null,
        sub_mode: 'milestone',
      };
      const config = {
        headers: {
          Authorization: `Token ${user_token}`,
        },
      };
      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'unit_qc/',
        payload,
        config
      );

      setUnitData(unitResponse.card_data);
      setTableFData(unitResponse.unit_metrics_report);
      setSummary(unitResponse.summary);

      if (unitResponse.status === 500) {
        resetData();
      }
    } catch (error) {
      // console.log('Error fetching unit QC:', error);
      resetData();
    } finally {
      setLoading(false); // Hide screen loader
      setLoading1(false); // Hide table loader
    }
  };

  // sticky filter bar
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Current scroll position
      const threshold = 100; // Adjust this value as needed
      setIsSticky(scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Helper function to update selected filters
  const handleSelectionChange = (type, value) => {
    const updatedSet = new Set(type);
    if (updatedSet.has(value)) {
      updatedSet.delete(value);
    } else {
      updatedSet.add(value);
    }
    return updatedSet;
  };

  const [slideIndex, setSlideIndex] = useState(0);
  const slideWidth = 300; // Adjust this based on your filter tag size

  const [showScrollButtons, setShowScrollButtons] = useState(false);

  const checkOverflow = () => {
    if (filterSummaryRef.current) {
      setShowScrollButtons(
        filterSummaryRef.current.scrollWidth >
        filterSummaryRef.current.clientWidth,
      );
    }
  };
  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow); // Recheck on window resize
    return () => window.removeEventListener('resize', checkOverflow);
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  // Function to handle the left scroll button click
  const handleLeftClick = () => {
    if (filterSummaryRef.current) {
      const newScrollLeft = Math.max(
        filterSummaryRef.current.scrollLeft - 200,
        0,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  // Function to handle the right scroll button click
  const handleRightClick = () => {
    if (filterSummaryRef.current) {
      const maxScrollLeft =
        filterSummaryRef.current.scrollWidth -
        filterSummaryRef.current.clientWidth;
      const newScrollLeft = Math.min(
        filterSummaryRef.current.scrollLeft + 200,
        maxScrollLeft,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const filterSummaryRef = useRef(null);

  // Start dragging (onMouseDown)
  const startDrag = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setIsDragging(true);
    setStartX(clientX);
    setScrollLeft(filterSummaryRef.current.scrollLeft);
    filterSummaryRef.current.style.cursor = 'grabbing'; // Change the cursor for desktop
    document.body.style.userSelect = 'none'; // Disable text selection globally
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const distance = clientX - startX;
    filterSummaryRef.current.scrollLeft = scrollLeft - distance;
  };

  const stopDrag = () => {
    setIsDragging(false);
    filterSummaryRef.current.style.cursor = 'grab';
    document.body.style.userSelect = ''; // Re-enable text selection globally
  };

  const removeUniversity = (universityId) => {
    setSelectedUniversities((prev) => {
      const newSet = new Set(prev);
      newSet.delete(universityId);
      return newSet;
    });
  };

  // Function to remove a program from the selected set
  const removeProgram = (programId) => {
    setSelectedPrograms((prev) => {
      const newSet = new Set(prev);
      newSet.delete(programId);
      return newSet;
    });
  };

  // Function to remove a timeline from the selected set
  const removeTimeline = (year) => {
    setSelectedTimelines((prev) => {
      const newSet = new Set(prev);
      newSet.delete(year);
      return newSet;
    });
  };

  // Function to remove a term from the selected set
  const removeTerm = (term) => {
    setSelectedTerms((prev) => {
      const newSet = new Set(prev);
      newSet.delete(term);
      return newSet;
    });
  };
  //fileter deleted selection
  const hasSelections =
    selectedUniversities.size > 0 ||
    selectedPrograms.size > 0 ||
    selectedTimelines.size > 0 ||
    selectedTerms.size > 0 ||
    selectedMilestonestype.size > 0 ||
    selectedMilestones.size > 0;

  const clearAllSelections = () => {
    setSelectedUniversities(new Set());
    setSelectedPrograms(new Set());
    setSelectedTimelines(new Set());
    setSelectedTerms(new Set());

    setPrograms([]);
    setTimelineYears([]);
    setTimelineTerms([]);

    fetchData();
    resetData();

    removeFromSessionStorage('appliedUniversitiesunitqc');
    removeFromSessionStorage('appliedProgramsunitqc');
    removeFromSessionStorage('appliedTimelinesunitqc');
    removeFromSessionStorage('appliedTermsunitqc');
    removeFromSessionStorage('appliedmilestoetypeunitqc');
    removeFromSessionStorage('appliedmilestoeunitqc');
    removeFromSessionStorage('selectedProgramsunitqc');
    removeFromSessionStorage('selectedUniversitiesunitqc');
    removeFromSessionStorage('selectedTimelinesunitqc');
    removeFromSessionStorage('selectedTermsunitqc');
    removeFromSessionStorage('selectedmilestonetypeunitqc');
    removeFromSessionStorage('selectedmilestoneunitqc');
  };

  const clearAllSelectionsmilesone1 = () => {
    setSelectedMilestonestype(new Set());
    setSelectedMilestones(new Set());

    setTimelineMilestone([]);
    setTimelineMilestonetype([]);
    removeFromSessionStorage('appliedmilestoetypeunitqc');
    removeFromSessionStorage('appliedmilestoeunitqc');
    removeFromSessionStorage('selectedmilestonetypeunitqc');
    removeFromSessionStorage('selectedmilestoneunitqc');
    fetchDataMileStonetype();
    fetchData();
  };
  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div className={`top-filter ${isSticky ? 'sticky-filter' : ''}`}>
            <div className=" mb-2">
              <div className="mt-md-0 mt-2">
                <div className="d-flex mt-1 flex-md-row flex-column  justify-content-between align-items-md-center align-items-end flex-wrap gap-2">
                  <div className="d-flex justify-content-end flex-wrap gap-2">
                    <Dropdown
                      isOpen={universityDropdownOpen}
                      toggle={toggleUniversityDropdown}
                    >
                      <DropdownToggle
                        className={`btn uni-bg ${universityDropdownOpen ? '' : ' '
                          }`}
                        caret
                        style={{ color: '#656565' }}
                      >
                        {/* University <i className="mdi mdi-chevron-down" /> */}
                        {loadingFilter ? 'Loading' : 'University'}{' '}
                        <i className="mdi mdi=chevron-down" />
                      </DropdownToggle>
                      {!loadingFilter && (
                        <>
                          <DropdownMenu className="p-0">
                            <input
                              type="text"
                              placeholder="Search Universities"
                              className="form-control"
                              value={universitySearch}
                              onChange={(e) =>
                                handleSearchChange(e, 'university')
                              }
                            />
                            {/* "Select All" Option */}
                            <DropdownItem
                              onClick={(e) => {
                                e.stopPropagation();
                                const allSelected =
                                  selectedUniversities.size ===
                                  universities.length;
                                const newSelection = new Set();

                                if (!allSelected) {
                                  // Select all universities
                                  universities.forEach((university) =>
                                    newSelection.add(university.id),
                                  );
                                  setSelectedPrograms(new Set());
                                  setSelectedTimelines(new Set());
                                  setSelectedTerms(new Set());
                                  setSelectedMilestones(new Set());
                                  setSelectedMilestonestype(new Set());
                                  setPrograms([]);
                                  setTimelineYears([]);
                                  setTimelineTerms([]);
                                  setTimelineMilestone([]);
                                  setTimelineMilestonetype([]);
                                } else {
                                  // Deselect all universities, applying the removeuniversity logic
                                  setSelectedPrograms(new Set());
                                  setSelectedTimelines(new Set());
                                  setSelectedTerms(new Set());
                                  setSelectedMilestones(new Set());
                                  setSelectedMilestonestype(new Set());
                                  setPrograms([]);
                                  setTimelineYears([]);
                                  setTimelineTerms([]);
                                  setTimelineMilestone([]);
                                  setTimelineMilestonetype([]);
                                }

                                setSelectedUniversities(newSelection); // Update the selected universities set
                                toggleUniversityDropdown(); // Close the dropdown
                              }}
                            >
                              {!loadingFilter && (
                                <>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={
                                        selectedUniversities.size ===
                                        universities.length
                                      } // Check if all are selected
                                      readOnly
                                    />
                                    <label className="form-check-label">
                                      All
                                    </label>
                                  </div>
                                </>
                              )}
                            </DropdownItem>
                            {/* {universities.map((university) => ( */}
                            {filterUniversities(universitySearch).map(
                              (university) => (
                                <DropdownItem
                                  key={university.id}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSelectItem(
                                      {
                                        id: university.id,
                                        name: university.university_name,
                                        removename: 'removeuniversity',
                                      },
                                      selectedUniversities,
                                      setSelectedUniversities,
                                      toggleUniversityDropdown,
                                    );
                                  }}
                                >
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={isItemSelected(
                                        university.id,
                                        selectedUniversities,
                                      )}
                                      readOnly
                                    />
                                    <label className="form-check-label">
                                      {university.university_name}
                                    </label>
                                  </div>
                                </DropdownItem>
                              ),
                            )}

                            {/* ))} */}
                          </DropdownMenu>
                        </>
                      )}
                    </Dropdown>
                    <Dropdown
                      isOpen={programDropdownOpen}
                      toggle={toggleProgramDropdown}
                    >
                      <DropdownToggle
                        disabled={programs.length === 0}
                        className={`btn program-bg ${programs.length > 0 ? '' : ' disable'
                          }`}
                        caret
                        style={{ color: '#656565' }}
                      >
                        Programs <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu className="p-0">
                        <input
                          type="text"
                          placeholder="Search Programs"
                          className="form-control"
                          value={programSearch}
                          onChange={(e) => handleSearchChange(e, 'program')}
                        />
                        {/* All Option */}
                        <DropdownItem
                          onClick={(e) => {
                            e.stopPropagation();
                            const allSelected =
                              selectedPrograms.size === programs.length;
                            const newSelection = new Set();
                            if (!allSelected) {
                              programs.forEach(([programId]) =>
                                newSelection.add(programId),
                              );
                              setSelectedTimelines(new Set());
                              setSelectedTerms(new Set());
                              setSelectedMilestones(new Set());
                              setSelectedMilestonestype(new Set());
                              setTimelineYears([]);
                              setTimelineTerms([]);
                              setTimelineMilestone([]);
                              setTimelineMilestonetype([]);
                            } else {
                              //deselect
                              setSelectedTimelines(new Set());
                              setSelectedTerms(new Set());
                              setSelectedMilestones(new Set());
                              setSelectedMilestonestype(new Set());

                              setTimelineYears([]);
                              setTimelineTerms([]);
                              setTimelineMilestone([]);
                              setTimelineMilestonetype([]);
                            }
                            setSelectedPrograms(newSelection);
                            toggleProgramDropdown();
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={
                                selectedPrograms.size === programs.length
                              }
                              readOnly
                            />
                            <label className="form-check-label">All</label>
                          </div>
                        </DropdownItem>
                        {/* {programs.map((program) => { */}
                        {/* const [programId, programName] = program;  // Destructure the ID and name from the array */}
                        {/* return ( */}
                        {filterPrograms(programSearch).map(
                          ([programId, programName]) => (
                            <DropdownItem
                              key={programId} // Use the programId as the key
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSelectItem(
                                  {
                                    id: programId,
                                    name: programName,
                                    removename: 'removeprograms',
                                  },
                                  selectedPrograms,
                                  setSelectedPrograms,
                                  toggleProgramDropdown,
                                );
                              }}
                            >
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={isItemSelected(
                                    programId,
                                    selectedPrograms,
                                  )}
                                  readOnly
                                />
                                <label className="form-check-label">
                                  {programName}
                                </label>
                              </div>
                            </DropdownItem>
                          ),
                        )}

                        {/* ); */}
                        {/* })} */}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className="d-flex justify-content-end flex-wrap gap-2">
                    <Dropdown
                      isOpen={timelineDropdownOpen}
                      toggle={toggleTimelineDropdown}
                    >
                      <DropdownToggle
                        disabled={timelineYears.length === 0}
                        className={`btn year-bg ${timelineYears.length > 0 ? '' : ' disable'
                          }`}
                        caret
                        style={{ color: '#656565' }}
                      >
                        Year <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu className="p-0">
                        <input
                          type="text"
                          placeholder="Search Year"
                          className="form-control"
                          value={timelineSearch}
                          onChange={(e) => handleSearchChange(e, 'timeline')}
                        />
                        {/* {timelineYears.map((year, index) => ( */}
                        {filterTimeline(timelineSearch).map((year, index) => (
                          <DropdownItem
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectItem(
                                {
                                  id: year,
                                  name: year,
                                  removename: 'removeyears',
                                },
                                selectedTimelines,
                                setSelectedTimelines,
                                toggleTimelineDropdown,
                              );
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isItemSelected(
                                  year,
                                  selectedTimelines,
                                )}
                                readOnly
                              />
                              <label className="form-check-label">{year}</label>
                            </div>
                          </DropdownItem>
                        ))}

                        {/* // ))} */}
                      </DropdownMenu>
                    </Dropdown>

                    <Dropdown
                      isOpen={termDropdownOpen}
                      toggle={toggleTermDropdown}
                    >
                      <DropdownToggle
                        disabled={timelineTerms.length === 0}
                        className={`btn stu-period-bg ${timelineTerms.length > 0 ? '' : ' disable'
                          }`}
                        caret
                        style={{ color: '#656565' }}
                      >
                        Study Period <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu className="p-0">
                        <input
                          type="text"
                          placeholder="Search Study Period"
                          className="form-control"
                          value={termSearch}
                          onChange={(e) => handleSearchChange(e, 'term')}
                        />
                        {/* {timelineTerms.map((term, index) => ( */}
                        {filterTerms(termSearch).map((term, index) => (
                          <DropdownItem
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectItem(
                                {
                                  id: term,
                                  name: term,
                                  removename: 'removestudyperiod',
                                },
                                selectedTerms,
                                setSelectedTerms,
                                toggleTermDropdown,
                              );
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isTermSelected(term, selectedTerms)}
                                readOnly
                              />
                              <label className="form-check-label">{term}</label>
                            </div>
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                    {/* Milestone Dropdown */}

                    <button
                      type="button"
                      className="btn btn-primary border-0 py-1 px-3 me-1"
                      onClick={handleApply}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* normal nav filter show */}
            <div className="filters-show">
              <div className="selected-filters">
                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-left"
                    onClick={handleLeftClick}
                  >
                    <i className="ri-arrow-left-s-line"></i>
                  </button>
                )}

                <div
                  className="filter-summary"
                  ref={filterSummaryRef}
                  onMouseDown={startDrag}
                  onMouseMove={handleMouseMove}
                  onMouseUp={stopDrag}
                  onMouseLeave={stopDrag}
                  onTouchStart={startDrag} // Touch equivalent of onMouseDown
                  onTouchMove={handleMouseMove} // Touch equivalent of onMouseMove
                  onTouchEnd={stopDrag} // Touch equivalent of onMouseUp
                >
                  {selectedUniversities.size > 0 && (
                    <div
                      className={`filter-item ${showScrollButtons ? 'ft-pl' : ''
                        }`}
                    >
                      {Array.from(selectedUniversities).map((universityId) => {
                        const university = universities.find(
                          (u) => u.id === universityId,
                        );
                        return university ? (
                          <p
                            key={universityId}
                            className="filter-tag university"
                          >
                            {university.university_name}{' '}
                            {/* <i
                                className="ri-close-line"
                                style={{ cursor: "pointer" }}
                                onClick={() => removeUniversity(universityId)}
                              ></i> */}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedPrograms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedPrograms).map((programId) => {
                        const program = programs.find(
                          ([id]) => id === programId,
                        );
                        return program ? (
                          <p key={programId} className="filter-tag programs">
                            {program[1]}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedTimelines.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTimelines).map((year, index) => (
                        <p key={index} className="filter-tag year">
                          {year}
                        </p>
                      ))}
                    </div>
                  )}

                  {selectedTerms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTerms).map((term, index) => (
                        <p key={index} className="filter-tag stu-period">
                          {term}
                        </p>
                      ))}
                    </div>
                  )}
                </div>

                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-right"
                    onClick={handleRightClick}
                  >
                    <i className="ri-arrow-right-s-line"></i>
                  </button>
                )}
              </div>

              <div className="">
                {hasSelections && (
                  <button
                    type="button"
                    className="clear-all-btn me-1"
                    onClick={clearAllSelections}
                  >
                    <i class="ri-close-fill"></i> Clear All
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="tab-tp-title">
            <h3 className="bold">Study Period Overview  </h3>
          </div>
          <div className="mt-1">
            <Row className="g-2">
              <Col xs={12}>
                <Card className="mb-0">
                  <CardBody>
                    {/* <div className="d-flex justify-content-end mb-2"> 
                  <CSVLink 
                    data={csvWithBom} 
                    filename={"unit_metrics_report.csv"} 
                    className="btn" 
                    style={{ border: '1px solid #ddd',width:'fit-content', borderRadius: '6px', padding: '4px 8px' }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                    </svg>
                  </CSVLink>
                  </div> */}
                    {loading1 ? ( // Show loader while loading
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: '200px' }}
                      >
                        <Spinner style={{ width: '3rem', height: '3rem' }} />
                      </div>
                    ) : (
                      <Row className="g-2">
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="peach-blossom-gradient border-yellow mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                % Students Engaged
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? unitData[0].overall_student_engaged
                                  : 0}
                              </h4>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="minty-gradient border-green mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                Students Engaged in 1-1 Sessions (%)
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? unitData[0].overall_phone_engaged
                                  : 0}
                              </h4>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="lavender-gradient border-lavender mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                {' '}
                                Avg. Time Spent in 1-1 Sessions Per Student (Mins)
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? unitData[0]
                                    .overall_average_call_time_per_student
                                  : 0}
                              </h4>
                            </CardBody>
                          </Card>
                        </Col>

                        {/* <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="peachy-gradient border-red mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                Students Marked Behind-Track (%)
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? unitData[0].overall_percentage_weak_students
                                  : 0}
                              </h4>
                            </CardBody>
                          </Card>
                        </Col> */}
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="minty-gradient border-green mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                Messages Responded Within 60 Mins (%)
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? `${unitData[0].overall_message_responsiveness}%`
                                  : '0%'}
                              </h4>{' '}
                              {/* Assuming this is a static value */}
                            </CardBody>
                          </Card>
                        </Col>

                        {/* <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="blush-gradient border-red mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                Calls With Red Flags (%)
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? unitData[0].overall_total_flags_count
                                  : 0}
                              </h4>
                            </CardBody>
                          </Card>
                        </Col> */}

                        {/* <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="sky-gradient border-sky mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                Teachers with Compliance Flags (%)
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? unitData[0]
                                      .overall_total_teachers_count_red_flags
                                  : 0}
                              </h4>
                            </CardBody>
                          </Card>
                        </Col> */}

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="lavender-gradient border-lavender mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                Avg. Grading Quality Score
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? unitData[0]
                                    .overall_average_assessment_grading_quality
                                  : 0}
                              </h4>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="minty-gradient border-green mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                Total 1-1 Sessions
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? unitData[0].total_sessions
                                  : 0}
                              </h4>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card className="peachy-gradient border-red mb-0 h-100">
                            <CardBody>
                              <p className="f-14 semibold">
                                Number of Group Sessions
                              </p>
                              <h4 className="bold">
                                {unitData && unitData.length > 0
                                  ? unitData[0].total_group_sessions
                                  : 0}
                              </h4>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>

              <Col>
                <Card className="mb-0">
                  <CardBody>
                    {loading1 ? ( // Show loader while loading
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: '200px' }}
                      >
                        <Spinner style={{ width: '3rem', height: '3rem' }} />
                      </div>
                    ) : (
                      <div>
                        <div className="d-md-flex align-items-center">
                          <div className="flex-grow-1 mb-md-0 mb-2">
                            <h5 className="f-16 bold">Units In The Study Period</h5>
                          </div>
                        </div>

                        <div className="">
                          <SummaryTableOverall
                            summarytabledata={summarytabledata}
                            appliedUniversities={appliedUniversities}
                            appliedTerms={appliedTerms}
                            appliedTimelines={appliedTimelines}
                            appliedPrograms={appliedPrograms}
                            appliedmilestonetype={appliedmilestonetype}
                            appliedmilestone={appliedmilestone}
                          />
                        </div>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>

              <Col>
                <Card className="mb-2">
                  <CardBody>
                    {loading ? ( // Show loader while loading
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: '200px' }}
                      >
                        <Spinner style={{ width: '3rem', height: '3rem' }} />
                      </div>
                    ) : (
                      <div>
                        <div className="d-md-flex align-items-center">
                          <div className="flex-grow-1 mb-md-0 mb-2">
                            <h5 className="f-16 bold">Key Metrics by Unit</h5>
                            <div className="d-flex justify-content-end flex-lg-nowrap flex-wrap gap-2">
                              <Dropdown
                                isOpen={milestonetypeDropdownOpen}
                                toggle={toggleMilestonetypeDropdown}
                              >
                                <DropdownToggle
                                  disabled={timelineMilestonetype.length === 0}
                                  className={`btn mi-stone-type-bg ${timelineMilestonetype.length > 0
                                      ? ''
                                      : ' disable'
                                    }`}
                                  caret
                                  style={{ color: '#000' }}
                                >
                                  Milestone Type
                                  {/* <span className="mandatory">*</span>*/}
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="p-0">
                                  {/* {timelineMilestonetype.map((milestone, index) => ( */}
                                  {/* Search Box */}
                                  {/* <input
                          type="text"
                          placeholder="Search Milestone Type"
                          className="form-control"
                          value={milestoneTypeSearch}
                          onChange={(e) => handleSearchChange(e, 'milestoneType')}
                        /> */}
                                  {filterMilestoneTypes(
                                    milestoneTypeSearch,
                                  ).map((milestone, index) => (
                                    <DropdownItem
                                      key={index}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSelectItem(
                                          {
                                            id: milestone,
                                            name: milestone,
                                            removename: 'removemilestonetype',
                                          },
                                          selectedMilestonestype,
                                          setSelectedMilestonestype,
                                          toggleMilestonetypeDropdown,
                                        );
                                      }}
                                    >
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={ismilestonetypemSelected(
                                            milestone,
                                            selectedMilestonestype,
                                          )}
                                          readOnly
                                        />
                                        <label className="form-check-label">
                                          {milestone}
                                        </label>
                                      </div>
                                    </DropdownItem>
                                  ))}

                                  {/* ))} */}
                                </DropdownMenu>
                              </Dropdown>
                              {/* Milestone Dropdown */}
                              <Dropdown
                                isOpen={milestoneDropdownOpen}
                                toggle={toggleMilestoneDropdown}
                              >
                                <DropdownToggle
                                  disabled={timelineMilestone.length === 0}
                                  className={`btn program-bg ${timelineMilestone.length > 0
                                      ? ''
                                      : ' disable'
                                    }`}
                                  caret
                                  style={{ color: '#656565' }}
                                >
                                  Milestone
                                  {/*<span className="mandatory">*</span>{" "}*/}
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="p-0">
                                  {/* {timelineMilestone.map((milestone, index) => ( */}
                                  {/* Search Box */}
                                  <input
                                    type="text"
                                    placeholder="Search Milestone"
                                    className="form-control"
                                    value={milestoneSearch}
                                    onChange={(e) =>
                                      handleSearchChange(e, 'milestone')
                                    }
                                  />
                                  {filterMilestones(milestoneSearch).map(
                                    (milestone, index) => (
                                      <DropdownItem
                                        key={index}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleSelectItem(
                                            {
                                              id: milestone,
                                              name: milestone,
                                              removename: 'removemilestone',
                                            },
                                            selectedMilestones,
                                            setSelectedMilestones,
                                            toggleMilestoneDropdown,
                                          );
                                        }}
                                      >
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={ismilestoneSelected(
                                              milestone,
                                              selectedMilestones,
                                            )}
                                            readOnly
                                          />
                                          <label className="form-check-label">
                                            {milestone}
                                          </label>
                                        </div>
                                      </DropdownItem>
                                    ),
                                  )}

                                  {/* ))} */}
                                </DropdownMenu>
                              </Dropdown>
                              <button
                                type="button"
                                className="btn btn-primary border-0 py-1 px-3 me-1"
                                onClick={handleApplyMilestone}
                              >
                                Apply
                              </button>
                            </div>
                            <div className="filters-show">
                              <div className="selected-filters">
                                {showScrollButtons && (
                                  <button
                                    className="slider-button slider-button-left"
                                    onClick={handleLeftClick}
                                  >
                                    <i className="ri-arrow-left-s-line"></i>
                                  </button>
                                )}

                                <div
                                  className="filter-summary"
                                  ref={filterSummaryRef}
                                  onMouseDown={startDrag}
                                  onMouseMove={handleMouseMove}
                                  onMouseUp={stopDrag}
                                  onMouseLeave={stopDrag}
                                  onTouchStart={startDrag} // Touch equivalent of onMouseDown
                                  onTouchMove={handleMouseMove} // Touch equivalent of onMouseMove
                                  onTouchEnd={stopDrag} // Touch equivalent of onMouseUp
                                >
                                  {selectedMilestonestype.size > 0 && (
                                    <div className="filter-item">
                                      {Array.from(selectedMilestonestype).map(
                                        (milestone, index) => (
                                          <p
                                            key={index}
                                            className="filter-tag mi-stone-type"
                                          >
                                            {milestone}
                                          </p>
                                        ),
                                      )}
                                    </div>
                                  )}
                                  {selectedMilestones.size > 0 && (
                                    <div className="filter-item">
                                      {Array.from(selectedMilestones).map(
                                        (milestone, index) => (
                                          <p
                                            key={index}
                                            className="filter-tag mi-stone"
                                          >
                                            {milestone}
                                          </p>
                                        ),
                                      )}
                                    </div>
                                  )}
                                </div>

                                {showScrollButtons && (
                                  <button
                                    className="slider-button slider-button-right"
                                    onClick={handleRightClick}
                                  >
                                    <i className="ri-arrow-right-s-line"></i>
                                  </button>
                                )}
                              </div>

                              <div className="">
                                {hasSelections && (
                                  <button
                                    type="button"
                                    className="clear-all-btn me-1"
                                    onClick={clearAllSelectionsmilesone1}
                                  >
                                    <i class="ri-close-fill"></i> Clear All
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="">
                          <SummaryTable
                            tableData={tableData}
                            appliedUniversities={appliedUniversities}
                            appliedTerms={appliedTerms}
                            appliedTimelines={appliedTimelines}
                            appliedPrograms={appliedPrograms}
                            appliedmilestonetype={appliedmilestonetype}
                            appliedmilestone={appliedmilestone}
                          />
                        </div>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  );
};

export default UnitQc;
